import { useEffect } from "react";
import logger from "../../../utils/LoggerFrontend";
import database from "../../../utils/FirebaseController";
import { ActionsAdAssistant } from "../../../Actions/ActionsAdAssistant/ActionsAdAssistant";

/**
 * Custom hook to subscribe to real-time ad lock updates.
 * @param {Array} selectedAds - Array of ad objects to subscribe to.
 * @param {Object} campaignData - Campaign data object containing the campaign ID.
 */
export function useRealtimeAdLock({ selectedAds, campaignData }) {
  useEffect(() => {
    const isEmpty =
      selectedAds.length === 0 ||
      !selectedAds ||
      !campaignData ||
      Object.keys(campaignData).length === 0;

    if (isEmpty) return;

    const onAdLockUpdate = (data) => {
      ActionsAdAssistant.getAdCombinations(campaignData.id);

      logger.log(
        "LockButtons:subscribeToRealtimeAdLock",
        `get realtime ad lock completed for ${data.id}`,
        {
          adId: data.id,
          data
        }
      );
    };

    const onAdLockError = (error) => {
      logger.log("error:LockButtons:subscribeToRealtimeAdLock", `get realtime ad lock error`, {
        error
      });
    };

    const firebaseRef = database.getRealtimeAdLock({
      ads: selectedAds,
      onUpdate: (newData) => onAdLockUpdate(newData),
      onError: (error) => onAdLockError(error)
    });

    if (firebaseRef) {
      logger.log(
        "LockButtons:subscribeToRealtimeAdLock",
        `attaching new listeners to realtime ads lock in ${campaignData.id}`,
        {
          selectedAds
        }
      );
    }

    return () => {
      if (firebaseRef) {
        logger.log(
          "LockButtons:subscribeToRealtimeAdLock",
          `detaching listeners to realtime ads lock in ${campaignData.id}`,
          {
            selectedAds
          }
        );
        firebaseRef();
      }
    };
  }, [selectedAds, campaignData]);
}
